// extracted by mini-css-extract-plugin
module.exports = {"inlineBlock":"StatementDescriptor_inlineBlock__3DsDY","validationTips":"StatementDescriptor_validationTips__2z7e5"};